import React from 'react';
import { LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { Modal, ModalProps } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ShowHide } from '@bcp-channels-sharedcomponents-reactjs/core';

interface ModalLocalProps extends Omit<ModalProps, 'visible'> {
	/** Set Modal Name */
	name: string;
	/** Set Event to be handle when modal close */
	onClose?: () => void;
	/** Set Event to be handle when modal opens */
	onOpen?: () => void;
}

export const ModalLocal: React.FC<ModalLocalProps> = (props) => {
	LoggerHelper.log('Module Modal Config >> Render', props);
	const { name } = props;

	return (
		<ShowHide name={name}>
			<Modal
				{...props}
				containerCustomStyle={{
					width: '100%',
					height: '100vh',
					overflow: 'hidden',
					position: 'fixed',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 120,
				}}
				visible
			/>
		</ShowHide>
	);
};
